/** @type {import('@nuxt/types').Plugin} */
const axiosExtend = ({ $axios, store }) => {
    if (store.state.csrf) {
        $axios.setHeader('x-csrf-token', store.state.csrf.token);
    }
};

export default axiosExtend;
